import { create } from 'zustand'
import { api } from './api'

export interface Whoami {
  key_id: string
  name: string
  scope: 'admin' | 'readonly'
  last_seen_at: string
  expires_at: string
}

interface AuthState {
  whoami: Whoami | null
  loading: boolean
  /** True once the first /api/auth/whoami check has completed (success OR failure). */
  initialized: boolean
  error: string | null
  refresh: () => Promise<void>
  login: (key: string) => Promise<void>
  logout: () => Promise<void>
}

export const useAuth = create<AuthState>((set) => ({
  whoami: null,
  loading: false,
  initialized: false,
  error: null,

  async refresh() {
    set({ loading: true, error: null })
    try {
      const me = await api<Whoami>('/api/auth/whoami')
      set({ whoami: me, loading: false, initialized: true })
    } catch {
      set({ whoami: null, loading: false, initialized: true, error: null })
    }
  },

  async login(key: string) {
    set({ loading: true, error: null })
    try {
      const res = await api<{ ok: boolean; whoami: Whoami }>(
        '/api/auth/login',
        { method: 'POST', body: JSON.stringify({ key }) },
      )
      set({ whoami: res.whoami, loading: false, initialized: true })
    } catch (e: unknown) {
      set({
        whoami: null,
        loading: false,
        initialized: true,
        error: e instanceof Error ? e.message : 'Login failed',
      })
      throw e
    }
  },

  async logout() {
    try {
      await api('/api/auth/logout', { method: 'POST' })
    } finally {
      set({ whoami: null, initialized: true })
    }
  },
}))
